import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IServiceState } from './service.reducer';
import * as fromReducer from './service.reducer';

const getServiceState = createFeatureSelector<IServiceState>('service');

export const getDownloads = createSelector(getServiceState, fromReducer.getDownloads);
export const getDownloadActionState = createSelector(
  getServiceState,
  fromReducer.getDownloadActionState
);
export const getUploadedFiles = createSelector(getServiceState, fromReducer.getUploadedFiles);
export const getUploadingActionState = createSelector(
  getServiceState,
  fromReducer.getUploadingActionState
);
